// extracted by mini-css-extract-plugin
export default {"text":"CommonText_text__niuAr"};